import { Typography, Avatar, Box, CardContent } from '@material-ui/core';
import Stack from '@mui/material/Stack';
import { InfoCard } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { ProfileInfo } from '@backstage/core-plugin-api';
import { GroupsCard } from './groups';

export const IdentityCard = () => {
  const { entity: user } = useEntity();
  const userData = {
    picture: (user.spec?.profile as ProfileInfo)?.picture ?? '',
    displayName: (user.spec?.profile as ProfileInfo)?.displayName ?? '',
    description: user.metadata.description ?? '',
  };
  const groupsData = {
    relations: user.relations ?? [],
  };

  return (
    <InfoCard title="Identity" variant="gridItem">
      <CardContent>
        {userData ? (
          <Box>
            <Stack
              direction="row"
              spacing={2}
              sx={{
                alignItems: 'center',
              }}
            >
              <Avatar
                src={userData.picture}
                style={{ width: '100px', height: '100px' }}
              />
              <Box>
                <Typography variant="h5">{userData.displayName}</Typography>
                {userData.description && (
                  <Typography variant="body2" color="textSecondary">
                    {userData.description}
                  </Typography>
                )}
              </Box>
            </Stack>
            {groupsData && (
              <Box mt={3}>
                <GroupsCard />
              </Box>
            )}
          </Box>
        ) : (
          <Typography>Could not fetch user info</Typography>
        )}
      </CardContent>
    </InfoCard>
  );
};
